// // import React, { useState } from "react";
// // import { Link } from "react-router-dom";
// // import {
// //   ChevronRight,
// //   Bell,
// //   MessageCircle,
// //   Calendar,
// //   Shield,
// //   ChartColumn,
// //   Users,
// //   TrendingUp,
// //   Zap,
// //   Settings,
// //   CheckCircle2,
// //   FileText,
// //   UserCheck,
// //   Rocket,
// //   CreditCard,
// //   Building2,
// //   PiggyBank,
// //   Briefcase,
// //   DollarSign,
// //   Landmark,
// //   Wallet,
// //   LineChart,
// //   PieChart,
// //   Lock,
// //   Timer,
// //   CalculatorIcon,
// // } from "lucide-react";
// // import Bank from "../../assets/banking.jpg";
// // import { Helmet } from "react-helmet-async";

// // const Banking = () => {
// //   const [activeTab, setActiveTab] = useState("all");

// //   const leadManagementFeatures = [
// //     {
// //       title: "Intelligent Lead Capture & Credit Scoring",
// //       content:
// //         "Capture leads from websites, apps, branches, call centers, and partners. AI-based scoring evaluates income, credit history, loan amount, and behavior to identify high-quality prospects for loans and financial products.",
// //       icon: CreditCard,
// //       category: "lead",
// //     },
// //     {
// //       title: "Automated Loan Application Nurturing",
// //       content:
// //         "Use SMS, email, and WhatsApp to guide leads through the loan journey—welcome messages, document steps, and updates. Automatically follow up with inactive or dropped leads.",
// //       icon: FileText,
// //       category: "nurturing",
// //     },
// //     {
// //       title: "Instant Loan Quote & Eligibility Checker",
// //       content:
// //         "Generate and send personalized loan quotes, EMI details, and eligibility instantly. Provides real-time rates, tenure options, and fee insights.",
// //       icon: CalculatorIcon,
// //       category: "quote",
// //     },
// //     {
// //       title: "Document Collection & KYC Automation",
// //       content:
// //         "Simplify document collection with automated KYC. Share secure upload links, track submissions, and speed up verification while ensuring compliance.",
// //       icon: Shield,
// //       category: "compliance",
// //     },
// //     {
// //       title: "Lead Distribution & RM Assignment",
// //       content:
// //         "Assign leads to the right managers based on type, location, or expertise. Improve response time and track performance with analytics.",
// //       icon: Users,
// //       category: "distribution",
// //     },
// //     {
// //       title: "Cross-sell & Upsell Automation",
// //       content:
// //         "Identify upsell opportunities using customer data. Recommend products like credit cards, insurance, and investments with personalized campaigns.",
// //       icon: PieChart,
// //       category: "cross-sell",
// //     },
// //   ];

// //   const bankingProducts = [
// //     {
// //       icon: Building2,
// //       title: "Home Loans",
// //       desc: "Purchase, construction, renovation",
// //       color: "from-blue-500 to-indigo-500",
// //     },
// //     {
// //       icon: Briefcase,
// //       title: "Personal Loans",
// //       desc: "Instant approval, low interest",
// //       color: "from-indigo-500 to-purple-500",
// //     },
// //     {
// //       icon: Landmark,
// //       title: "Business Loans",
// //       desc: "Working capital, expansion",
// //       color: "from-purple-500 to-pink-500",
// //     },
// //     {
// //       icon: CreditCard,
// //       title: "Credit Cards",
// //       desc: "Rewards, travel, premium",
// //       color: "from-pink-500 to-rose-500",
// //     },
// //     {
// //       icon: PiggyBank,
// //       title: "Savings Accounts",
// //       desc: "High interest, zero balance",
// //       color: "from-green-500 to-emerald-500",
// //     },
// //     {
// //       icon: Wallet,
// //       title: "Wealth Management",
// //       desc: "Investments, portfolio",
// //       color: "from-amber-500 to-orange-500",
// //     },
// //   ];

// //   const lmsWorkflows = [
// //     {
// //       icon: UserCheck,
// //       title: "Lead Capture",
// //       steps: [
// //         "Website Forms",
// //         "Mobile App",
// //         "Branch Walk-ins",
// //         "Call Center",
// //         "Partner Referrals",
// //       ],
// //     },
// //     {
// //       icon: CalculatorIcon,
// //       title: "Eligibility & Quote",
// //       steps: [
// //         "Credit Score Check",
// //         "Income Verification",
// //         "Loan Quote Generation",
// //         "EMI Calculator",
// //         "Offer Delivery",
// //       ],
// //     },
// //     {
// //       icon: Shield,
// //       title: "Documentation & KYC",
// //       steps: [
// //         "Document Request",
// //         "Secure Upload",
// //         "Auto-verification",
// //         "Compliance Check",
// //         "Approval Queue",
// //       ],
// //     },
// //     {
// //       icon: Rocket,
// //       title: "Disbursement & Onboarding",
// //       steps: [
// //         "Loan Sanction",
// //         "Digital Signing",
// //         "Fund Disbursement",
// //         "Welcome Kit",
// //         "Cross-sell Offers",
// //       ],
// //     },
// //   ];

// //   const lmsBenefits = [
// //     {
// //       icon: Timer,
// //       title: "90% Faster Loan Processing",
// //       desc: "Automated verification reduces approval time",
// //     },
// //     {
// //       icon: TrendingUp,
// //       title: "5x Higher Conversion",
// //       desc: "AI-powered scoring prioritizes qualified leads",
// //     },
// //     {
// //       icon: DollarSign,
// //       title: "40% Lower Acquisition Cost",
// //       desc: "Optimized campaigns reduce CAC significantly",
// //     },
// //     {
// //       icon: Lock,
// //       title: "100% KYC Compliance",
// //       desc: "Automated verification ensures compliance",
// //     },
// //   ];

// //   const coreFeatures = [
// //     {
// //       icon: Bell,
// //       title: "Instant Loan Alerts",
// //       desc: "Notify leads about loan offers and interest rate changes instantly",
// //     },
// //     {
// //       icon: MessageCircle,
// //       title: "Automated Follow-ups",
// //       desc: "Smart nurturing sequences for application abandonment",
// //     },
// //     {
// //       icon: Calendar,
// //       title: "Payment Reminders",
// //       desc: "EMI reminders and overdue notifications",
// //     },
// //     {
// //       icon: Shield,
// //       title: "Secure KYC",
// //       desc: "End-to-end encrypted document collection",
// //     },
// //     {
// //       icon: LineChart,
// //       title: "Credit Scoring",
// //       desc: "AI-powered creditworthiness assessment",
// //     },
// //     {
// //       icon: ChartColumn,
// //       title: "Analytics Dashboard",
// //       desc: "Track conversions, ROI, and agent performance",
// //     },
// //   ];

// //   const scrollItems = [
// //     "🏦 Website Inquiry",
// //     "📊 Credit Check",
// //     "💰 Loan Quote",
// //     "📋 Application Started",
// //     "📄 Document Upload",
// //     "✅ KYC Verified",
// //     "🏷️ Loan Sanctioned",
// //     "💵 Disbursement Complete",
// //   ];

// //   const scrollItems2 = [
// //     "🎯 High-Intent Lead Alert",
// //     "📱 EMI Calculator Used",
// //     "🏠 Property Documents",
// //     "🔒 Digital Signing",
// //     "💳 Credit Card Offer",
// //     "📈 Investment Portfolio",
// //     "⭐ Review Request",
// //     "🔄 Refinance Offer",
// //   ];

// //   // Helper components
// //   const Calculator = (props) => (
// //     <svg
// //       {...props}
// //       xmlns="http://www.w3.org/2000/svg"
// //       width="24"
// //       height="24"
// //       viewBox="0 0 24 24"
// //       fill="none"
// //       stroke="currentColor"
// //       strokeWidth="2"
// //       strokeLinecap="round"
// //       strokeLinejoin="round"
// //     >
// //       <rect x="4" y="2" width="16" height="20" rx="2" />
// //       <line x1="8" y1="6" x2="16" y2="6" />
// //       <line x1="8" y1="10" x2="16" y2="10" />
// //       <line x1="8" y1="14" x2="12" y2="14" />
// //       <line x1="8" y1="18" x2="12" y2="18" />
// //       <line x1="16" y1="14" x2="16" y2="14" />
// //       <line x1="16" y1="18" x2="16" y2="18" />
// //     </svg>
// //   );

// //   const filteredFeatures =
// //     activeTab === "all"
// //       ? leadManagementFeatures
// //       : leadManagementFeatures.filter((f) => f.category === activeTab);

// //   return (
// //     <>
// //       <Helmet>
// //         <title>
// //           Banking Lead Management System | LMSBots - Loans, KYC & Automation
// //         </title>

// //         <meta
// //           name="description"
// //           content="AI-powered banking lead management system to capture, qualify and convert leads for loans, credit cards, and financial products. Automate KYC, loan processing, and customer onboarding with LMSBots."
// //         />

// //         <meta
// //           name="keywords"
// //           content="banking CRM, loan lead management system, financial CRM software, KYC automation, loan management system India, banking automation software, LMSBots"
// //         />

// //         {/* Canonical */}
// //         <link
// //           rel="canonical"
// //           href="https://lmsbots.com/solutions/banking-finance"
// //         />

// //         {/* Open Graph (Facebook, LinkedIn) */}
// //         <meta property="og:type" content="website" />
// //         <meta
// //           property="og:title"
// //           content="Banking Lead Management System | LMSBots"
// //         />
// //         <meta
// //           property="og:description"
// //           content="Automate loan processing, KYC, and lead conversion with LMSBots banking CRM. Increase conversions and reduce processing time."
// //         />
// //         <meta
// //           property="og:url"
// //           content="https://lmsbots.com/solutions/solutions/banking-finance"
// //         />
// //         <meta
// //           property="og:image"
// //           content="https://lmsbots.com/og-banking.jpg"
// //         />

// //         {/* Twitter SEO */}
// //         <meta name="twitter:card" content="summary_large_image" />
// //         <meta
// //           name="twitter:title"
// //           content="Banking CRM & Lead Management | LMSBots"
// //         />
// //         <meta
// //           name="twitter:description"
// //           content="AI-powered banking CRM for loans, KYC, and financial lead automation."
// //         />
// //         <meta
// //           name="twitter:image"
// //           content="https://lmsbots.com/og-banking.jpg"
// //         />

// //         {/* Structured Data (VERY IMPORTANT FOR SEO) */}
// //         <script type="application/ld+json">
// //           {JSON.stringify({
// //             "@context": "https://schema.org",
// //             "@type": "SoftwareApplication",
// //             name: "LMSBots Banking Lead Management System",
// //             url: "https://lmsbots.com/solutions/solutions/banking-finance",
// //             applicationCategory: "BusinessApplication",
// //             operatingSystem: "Web",
// //             description:
// //               "AI-powered banking lead management software for loans, KYC automation, and financial services CRM.",
// //             offers: {
// //               "@type": "Offer",
// //               price: "0",
// //               priceCurrency: "INR",
// //             },
// //           })}
// //         </script>
// //       </Helmet>

// //       <main className="font-sans antialiased overflow-x-hidden">
// //         <div className="w-full overflow-hidden">
// //           <style>{`
// //           @keyframes scroll-left {
// //             0% { transform: translateX(0); }
// //             100% { transform: translateX(-50%); }
// //           }
// //           @keyframes scroll-right {
// //             0% { transform: translateX(-50%); }
// //             100% { transform: translateX(0); }
// //           }
// //           .animate-scroll-left {
// //             display: flex;
// //             width: max-content;
// //             animation: scroll-left 40s linear infinite;
// //           }
// //           .animate-scroll-right {
// //             display: flex;
// //             width: max-content;
// //             animation: scroll-right 40s linear infinite;
// //           }
// //           .pause-on-hover:hover {
// //             animation-play-state: paused;
// //           }
// //           @keyframes float {
// //             0%, 100% { transform: translateY(0px); }
// //             50% { transform: translateY(-20px); }
// //           }
// //           .animate-float {
// //             animation: float 6s ease-in-out infinite;
// //           }
// //         `}</style>

// //           {/* HERO SECTION - Banking Specific */}

// //           <section className="relative bg-gradient-to-br from-white via-indigo-50 to-purple-50 overflow-hidden">
// //             {/* Background Blobs */}
// //             <div className="absolute top-10 right-10 w-72 h-72 bg-indigo-300/30 rounded-full blur-3xl opacity-40 animate-pulse"></div>
// //             <div className="absolute bottom-10 left-10 w-72 h-72 bg-purple-300/30 rounded-full blur-3xl opacity-40 animate-pulse"></div>

// //             <div className="container mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28 flex flex-col md:flex-row items-center gap-14">
// //               {/* TEXT CONTENT (FIRST ON MOBILE) */}
// //               <div className="w-full md:w-1/2 flex flex-col items-start text-center md:text-left order-1 md:order-1">
// //                 {/* Badge */}
// //                 <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-100 border border-indigo-200 rounded-full mb-6">
// //                   <Zap className="w-4 h-4 text-indigo-600" />
// //                   <span className="text-xs font-semibold text-indigo-600">
// //                     Lead Management System for Banking & Finance
// //                   </span>
// //                 </div>

// //                 {/* Heading */}
// //                 <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold text-slate-900 leading-tight mb-6">
// //                   Turn Every Banking Lead into a{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Valued Customer
// //                   </span>
// //                 </h1>

// //                 {/* Description */}
// //                 <p className="text-lg text-slate-600 leading-relaxed mb-8 max-w-xl">
// //                   Capture, qualify, and convert banking leads with AI-powered
// //                   automation. From loan inquiries to wealth management—manage
// //                   your entire financial services pipeline in one intelligent
// //                   platform.
// //                 </p>

// //                 {/* Button */}
// //                 <div className="flex flex-wrap gap-4 justify-center md:justify-start">
// //                   <Link to="/login">
// //                     <button className="group inline-flex items-center gap-2 px-6 py-3 text-white bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
// //                       Request a Demo
// //                       <ChevronRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
// //                     </button>
// //                   </Link>
// //                 </div>
// //               </div>

// //               {/* IMAGE (SECOND ON MOBILE, RIGHT ON DESKTOP) */}
// //               <div className="w-full md:w-1/2 flex justify-center order-2 md:order-2">
// //                 <div className="relative w-full max-w-md lg:max-w-2xl">
// //                   {/* Glow Effect */}
// //                   <div className="absolute -inset-6 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-3xl blur-2xl opacity-30"></div>

// //                   {/* Image */}
// //                   <img
// //                     src={Bank}
// //                     alt="Banking Lead Management Dashboard"
// //                     className="relative w-full rounded shadow object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </section>

// //           {/* LEAD MANAGEMENT FEATURES SECTION WITH TABS */}
// //           <section className="bg-gradient-to-br from-white via-indigo-50 to-purple-50 py-20 lg:py-32 -mt-24">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="text-center max-w-4xl mx-auto mb-16 lg:mb-24">
// //                 <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-50 rounded-full border border-purple-100 mb-6">
// //                   <Settings className="w-4 h-4 text-purple-600" />
// //                   <span className="text-xs font-semibold text-purple-600">
// //                     Complete Banking Solution
// //                   </span>
// //                 </div>
// //                 <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
// //                   How LMSBots Helps{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Banks & Financial Institutions
// //                   </span>
// //                 </h2>
// //                 <p className="text-lg text-slate-600 mt-4 max-w-2xl mx-auto">
// //                   Everything you need to capture, nurture, and convert banking
// //                   leads—all in one intelligent platform
// //                 </p>
// //               </div>

// //               {/* Tab Navigation */}
// //               <div className="flex flex-wrap justify-center gap-3 mb-12">
// //                 {[
// //                   { id: "all", label: "All Features", icon: Zap },
// //                   { id: "lead", label: "Lead Capture", icon: Users },
// //                   { id: "nurturing", label: "Nurturing", icon: MessageCircle },
// //                   { id: "quote", label: "Loan Quotes", icon: Calculator },
// //                   { id: "compliance", label: "KYC & Compliance", icon: Shield },
// //                   { id: "cross-sell", label: "Cross-sell", icon: PieChart },
// //                 ].map((tab) => {
// //                   const Icon = tab.icon;
// //                   return (
// //                     <button
// //                       key={tab.id}
// //                       onClick={() => setActiveTab(tab.id)}
// //                       className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-xl font-medium transition-all duration-300 ${
// //                         activeTab === tab.id
// //                           ? "bg-indigo-600 text-white shadow-lg"
// //                           : "bg-white text-slate-600 hover:bg-indigo-50 border border-slate-200"
// //                       }`}
// //                     >
// //                       <Icon className="w-4 h-4" />
// //                       <span>{tab.label}</span>
// //                     </button>
// //                   );
// //                 })}
// //               </div>

// //               <div className="grid lg:grid-cols-2 gap-8">
// //                 {filteredFeatures.map((feature, idx) => {
// //                   const Icon = feature.icon;
// //                   return (
// //                     <div
// //                       key={idx}
// //                       className="bg-white rounded-2xl p-6 shadow-lg border border-slate-100 hover:shadow-xl transition-all group"
// //                     >
// //                       <div className="flex items-start gap-4">
// //                         <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-3 rounded-xl group-hover:scale-110 transition-transform">
// //                           <Icon className="w-6 h-6 text-indigo-600" />
// //                         </div>
// //                         <div>
// //                           <h3 className="text-xl font-bold text-slate-900 mb-2">
// //                             {feature.title}
// //                           </h3>
// //                           <p className="text-slate-600 leading-relaxed">
// //                             {feature.content}
// //                           </p>
// //                         </div>
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>

// //           {/* BANKING PRODUCTS SECTION - CARDS WITH GRADIENTS */}
// //           <section className="py-20 bg-white relative -mt-16">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="text-center max-w-3xl mx-auto mb-16">
// //                 <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wider mb-4 block">
// //                   Financial Products
// //                 </span>
// //                 <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
// //                   Manage Leads Across{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     All Banking Products
// //                   </span>
// //                 </h2>
// //                 <p className="text-xl text-slate-600">
// //                   Specialized workflows for every financial service
// //                 </p>
// //               </div>

// //               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
// //                 {bankingProducts.map((product, idx) => {
// //                   const Icon = product.icon;
// //                   return (
// //                     <div
// //                       key={idx}
// //                       className={`group relative overflow-hidden rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all bg-gradient-to-br ${product.color} text-white`}
// //                     >
// //                       <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full -translate-y-16 translate-x-16 group-hover:scale-150 transition-transform duration-500"></div>
// //                       <div className="relative z-10">
// //                         <div className="bg-white/20 w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
// //                           <Icon className="w-7 h-7 text-white" />
// //                         </div>
// //                         <h3 className="text-xl font-bold mb-2">
// //                           {product.title}
// //                         </h3>
// //                         <p className="text-white/80 text-sm">{product.desc}</p>
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>

// //           {/* LMS WORKFLOW SECTION - TIMELINE STYLE */}
// //           <section className="py-20 bg-gradient-to-r from-indigo-50 to-purple-50">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="text-center max-w-3xl mx-auto mb-16">
// //                 <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wider mb-4 block">
// //                   Lead Management Workflow
// //                 </span>
// //                 <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
// //                   From{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Lead to Customer
// //                   </span>{" "}
// //                   in 4 Simple Steps
// //                 </h2>
// //                 <p className="text-xl text-slate-600">
// //                   Automated workflows that guide prospects through your banking
// //                   sales pipeline
// //                 </p>
// //               </div>

// //               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
// //                 {lmsWorkflows.map((workflow, idx) => {
// //                   const Icon = workflow.icon;
// //                   return (
// //                     <div key={idx} className="relative group">
// //                       <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all border border-slate-100 h-full">
// //                         <div className="bg-gradient-to-br from-indigo-100 to-purple-100 w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
// //                           <Icon className="w-6 h-6 text-indigo-600" />
// //                         </div>
// //                         <div className="absolute top-6 right-6 text-2xl font-bold text-indigo-200">
// //                           0{idx + 1}
// //                         </div>
// //                         <h3 className="text-xl font-bold text-slate-900 mb-4">
// //                           {workflow.title}
// //                         </h3>
// //                         <ul className="space-y-2">
// //                           {workflow.steps.map((step, i) => (
// //                             <li
// //                               key={i}
// //                               className="flex items-center gap-2 text-slate-600 text-sm"
// //                             >
// //                               <CheckCircle2 className="w-4 h-4 text-indigo-500 flex-shrink-0" />
// //                               <span>{step}</span>
// //                             </li>
// //                           ))}
// //                         </ul>
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>

// //           {/* BENEFITS SECTION - STATS CARDS */}
// //           <section className="py-20 bg-white">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="grid lg:grid-cols-2 gap-12 items-center">
// //                 <div className="order-2 lg:order-1">
// //                   <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-50 rounded-full border border-indigo-200 mb-6">
// //                     <TrendingUp className="w-4 h-4 text-indigo-600" />
// //                     <span className="text-xs font-semibold text-indigo-600">
// //                       Key Benefits
// //                     </span>
// //                   </div>
// //                   <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
// //                     Why Banking Institutions{" "}
// //                     <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                       Choose LMSBots
// //                     </span>
// //                   </h2>
// //                   <p className="text-lg text-slate-600 mb-8">
// //                     Our lead management system helps you close more loans faster
// //                     with intelligent automation and real-time insights
// //                   </p>
// //                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
// //                     {lmsBenefits.map((benefit, idx) => {
// //                       const Icon = benefit.icon;
// //                       return (
// //                         <div
// //                           key={idx}
// //                           className="bg-gradient-to-br from-slate-50 to-white rounded-xl p-4 shadow-sm border border-slate-100 hover:shadow-md transition-all group"
// //                         >
// //                           <div className="flex items-center gap-3 mb-2">
// //                             <div className="bg-indigo-100 p-2 rounded-lg group-hover:bg-indigo-600 transition-colors">
// //                               <Icon className="w-5 h-5 text-indigo-600 group-hover:text-white transition-colors" />
// //                             </div>
// //                             <h4 className="font-bold text-slate-900">
// //                               {benefit.title}
// //                             </h4>
// //                           </div>
// //                           <p className="text-sm text-slate-600 pl-11">
// //                             {benefit.desc}
// //                           </p>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 </div>
// //                 <div className="order-1 lg:order-2 relative">
// //                   <div className="absolute -inset-4 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-3xl opacity-20 blur-2xl animate-pulse"></div>
// //                   <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden">
// //                     <img
// //                       src="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
// //                       alt="Banking Analytics Dashboard"
// //                       className="w-full h-auto object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </section>

// //           {/* CORE FEATURES SECTION - WITH HOVER EFFECTS */}

// //           <section className="relative py-16 bg-gradient-to-b from-white via-indigo-50/60 to-purple-50/60 overflow-hidden">
// //             {/* Background Blobs */}
// //             <div className="absolute top-0 left-0 w-72 h-72 bg-purple-300/20 rounded-full blur-3xl"></div>
// //             <div className="absolute bottom-0 right-0 w-72 h-72 bg-indigo-300/20 rounded-full blur-3xl"></div>

// //             <div className="container mx-auto px-6 lg:px-12 relative z-10">
// //               {/* Heading */}
// //               <div className="text-center max-w-3xl mx-auto mb-10">
// //                 <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-5 leading-tight">
// //                   Powerful Features for{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Banking Success
// //                   </span>
// //                 </h2>
// //                 <p className="text-lg lg:text-xl text-slate-600">
// //                   Everything you need to streamline lead management and close
// //                   more loans efficiently
// //                 </p>
// //               </div>

// //               {/* Cards */}
// //               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto">
// //                 {coreFeatures.map((feature, idx) => {
// //                   const Icon = feature.icon;
// //                   return (
// //                     <div
// //                       key={idx}
// //                       className="group relative backdrop-blur-xl bg-white/70 border border-white/40 rounded-3xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2"
// //                     >
// //                       {/* Icon */}
// //                       <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-2xl bg-gradient-to-r from-indigo-500 to-purple-500 text-white shadow-lg group-hover:scale-110 transition-transform duration-300">
// //                         <Icon className="w-6 h-6" />
// //                       </div>

// //                       {/* Title */}
// //                       <h3 className="text-xl font-semibold text-slate-900 mb-2 group-hover:text-indigo-600 transition-colors">
// //                         {feature.title}
// //                       </h3>

// //                       {/* Description */}
// //                       <p className="text-slate-600 leading-relaxed text-sm">
// //                         {feature.desc}
// //                       </p>

// //                       {/* Hover Border Glow */}
// //                       <div className="absolute inset-0 rounded-3xl border border-transparent group-hover:border-indigo-200 transition-all duration-300"></div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>

// //           {/* SCROLLING LEAD JOURNEY SECTION */}
// //           <section className="bg-white py-20 lg:py-20">
// //             <div className="container mx-auto px-6 lg:px-12 text-center">
// //               <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4 tracking-tight">
// //                 The Complete{" "}
// //                 <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                   Banking Lead Journey
// //                 </span>
// //               </h2>
// //               <p className="text-xl text-slate-500 max-w-2xl mx-auto mb-8">
// //                 See how leads move through your automated sales pipeline—from
// //                 first inquiry to loan disbursement
// //               </p>
// //               <div className="relative mt-16 mb-16 overflow-hidden">
// //                 <div className="absolute inset-y-0 left-0 w-40 z-10 bg-gradient-to-r from-white to-transparent"></div>
// //                 <div className="absolute inset-y-0 right-0 w-40 z-10 bg-gradient-to-l from-white to-transparent"></div>
// //                 <div className="animate-scroll-left gap-8 mb-8">
// //                   {scrollItems.map((item, i) => (
// //                     <div
// //                       key={i}
// //                       className="px-8 py-4 bg-gradient-to-r from-indigo-50 to-purple-50 border border-indigo-100 rounded-3xl text-slate-700 font-semibold text-xl whitespace-nowrap transition-all shadow-sm mx-4 cursor-default hover:shadow-md"
// //                     >
// //                       {item}
// //                     </div>
// //                   ))}
// //                 </div>
// //                 <div className="animate-scroll-right gap-8">
// //                   {scrollItems2.map((item, i) => (
// //                     <div
// //                       key={i}
// //                       className="px-8 py-4 bg-gradient-to-r from-indigo-50 to-purple-50 border border-indigo-100 rounded-3xl text-slate-700 font-semibold text-xl whitespace-nowrap transition-all shadow-sm mx-4 cursor-default hover:shadow-md"
// //                     >
// //                       {item}
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             </div>
// //           </section>
// //         </div>
// //       </main>
// //     </>
// //   );
// // };

// // export default Banking;








// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { motion, useReducedMotion } from "framer-motion";
// import {
//   ArrowRight,
//   Bell,
//   MessageCircle,
//   Calendar,
//   Shield,
//   BarChart3,
//   Users,
//   TrendingUp,
//   Zap,
//   Settings,
//   CheckCircle2,
//   FileText,
//   UserCheck,
//   Rocket,
//   CreditCard,
//   Building2,
//   PiggyBank,
//   Briefcase,
//   Landmark,
//   Wallet,
//   LineChart,
//   PieChart,
//   Lock,
//   Timer,
//   Calculator,
//   Target,
//   ChevronDown,
//   Search,
//   Smartphone,
//   Pencil,
//   Star,
//   RefreshCw,
// } from "lucide-react";
// import Bank from "../../assets/banking.jpg";
// // NOTE: adjust this path to wherever Seo.js lives in your project
// import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";

// const PATH = "/solutions/banking-finance";
// const TITLE = "Banking Lead Management System & Loan CRM | LMSBOTS";
// const DESCRIPTION =
//   "LMSBOTS banking CRM helps banks, NBFCs and loan agencies capture loan leads, score and route them to RMs, automate KYC follow-ups and EMI reminders, and convert faster.";

// // ---------- Static content (outside the component so it isn't rebuilt on every render) ----------
// const HERO_POINTS = ["Loan lead scoring", "KYC workflows", "EMI reminders"];

// const FEATURE_TABS = [
//   { id: "all", label: "All Features", icon: Zap },
//   { id: "lead", label: "Lead Capture", icon: Users },
//   { id: "nurturing", label: "Nurturing", icon: MessageCircle },
//   { id: "quote", label: "Loan Quotes", icon: Calculator },
//   { id: "compliance", label: "KYC & Compliance", icon: Shield },
//   { id: "distribution", label: "RM Assignment", icon: UserCheck },
//   { id: "cross-sell", label: "Cross-sell", icon: PieChart },
// ];

// const LEAD_FEATURES = [
//   {
//     title: "Intelligent Lead Capture & Scoring",
//     content:
//       "Capture leads from websites, apps, branches, call centers, and partners. Score them on income, loan amount, product interest, and engagement so your team calls the highest-intent prospects first.",
//     icon: CreditCard,
//     category: "lead",
//   },
//   {
//     title: "Automated Loan Application Nurturing",
//     content:
//       "Guide leads through the loan journey with SMS, email, and WhatsApp: welcome messages, document checklists, and status updates. Inactive or dropped applications get follow-ups automatically.",
//     icon: FileText,
//     category: "nurturing",
//   },
//   {
//     title: "Instant Loan Quote & Eligibility Checker",
//     content:
//       "Generate and send personalized loan quotes, EMI details, and eligibility summaries instantly, with rates, tenure options, and fee breakdowns your team defines.",
//     icon: Calculator,
//     category: "quote",
//   },
//   {
//     title: "Document Collection & KYC Workflow",
//     content:
//       "Share secure upload links, track which documents are pending, and move applications to your verification queue faster, while your team keeps control of approvals and compliance checks.",
//     icon: Shield,
//     category: "compliance",
//   },
//   {
//     title: "Lead Distribution & RM Assignment",
//     content:
//       "Assign leads to the right relationship manager by product, location, or expertise. Shorten response time and review each RM's performance in one dashboard.",
//     icon: Users,
//     category: "distribution",
//   },
//   {
//     title: "Cross-sell & Upsell Automation",
//     content:
//       "Spot opportunities in existing customer data and recommend credit cards, insurance, and investment products through personalized campaigns.",
//     icon: PieChart,
//     category: "cross-sell",
//   },
// ];

// const PRODUCTS = [
//   { icon: Building2, title: "Home Loans", desc: "Purchase, construction, and renovation leads" },
//   { icon: Briefcase, title: "Personal Loans", desc: "Fast-moving, high-volume inquiries" },
//   { icon: Landmark, title: "Business Loans", desc: "Working capital and expansion financing" },
//   { icon: CreditCard, title: "Credit Cards", desc: "Rewards, travel, and premium card leads" },
//   { icon: PiggyBank, title: "Savings Accounts", desc: "Account opening and onboarding follow-ups" },
//   { icon: Wallet, title: "Wealth Management", desc: "Investment and portfolio inquiries" },
// ];

// const AUDIENCE = [
//   {
//     icon: Landmark,
//     title: "Banks & cooperative banks",
//     desc: "Bring branch, digital, and call-center leads into one pipeline with clear RM ownership.",
//   },
//   {
//     icon: Building2,
//     title: "NBFCs & housing finance",
//     desc: "Handle high loan-inquiry volumes with automated follow-ups and document tracking.",
//   },
//   {
//     icon: Smartphone,
//     title: "Fintech lenders",
//     desc: "Connect app and web sign-ups to scoring, nurturing, and quick quote delivery.",
//   },
//   {
//     icon: UserCheck,
//     title: "DSAs & loan agencies",
//     desc: "Track partner-sourced leads, agent performance, and payout-ready conversion data.",
//   },
// ];

// const WORKFLOWS = [
//   {
//     icon: UserCheck,
//     title: "Lead Capture",
//     steps: ["Website forms", "Mobile app", "Branch walk-ins", "Call center", "Partner referrals"],
//   },
//   {
//     icon: Calculator,
//     title: "Eligibility & Quote",
//     steps: ["Lead scoring", "Income details", "Loan quote generation", "EMI calculator", "Offer delivery"],
//   },
//   {
//     icon: Shield,
//     title: "Documentation & KYC",
//     steps: ["Document request", "Secure upload", "Pending-document tracking", "Verification queue", "Approval handoff"],
//   },
//   {
//     icon: Rocket,
//     title: "Disbursement & Onboarding",
//     steps: ["Loan sanction", "Digital signing", "Disbursement update", "Welcome message", "Cross-sell offers"],
//   },
// ];

// const BENEFITS = [
//   {
//     icon: Timer,
//     title: "Faster loan processing",
//     desc: "Automated document requests and status updates replace manual chasing.",
//   },
//   {
//     icon: Target,
//     title: "Better lead prioritization",
//     desc: "Scoring surfaces high-intent applicants so RMs contact them first.",
//   },
//   {
//     icon: TrendingUp,
//     title: "Smarter acquisition spend",
//     desc: "See which channels and partners bring qualified applicants, and invest accordingly.",
//   },
//   {
//     icon: Lock,
//     title: "Audit-ready records",
//     desc: "Every call, message, and document is logged against the lead for easy review.",
//   },
// ];

// const CORE_FEATURES = [
//   { icon: Bell, title: "Instant Loan Alerts", desc: "Notify leads about offers and interest rate changes in seconds." },
//   { icon: MessageCircle, title: "Automated Follow-ups", desc: "Smart sequences re-engage applicants who abandoned an application." },
//   { icon: Calendar, title: "Payment Reminders", desc: "Send EMI reminders and overdue notifications on schedule." },
//   { icon: Shield, title: "Secure Document Collection", desc: "Collect KYC documents through secure upload links." },
//   { icon: LineChart, title: "Lead Scoring", desc: "Rank applicants by profile and engagement to focus effort." },
//   { icon: BarChart3, title: "Analytics Dashboard", desc: "Track conversions, ROI, and RM performance in real time." },
// ];

// const JOURNEY_1 = [
//   { icon: Search, label: "Website inquiry" },
//   { icon: LineChart, label: "Lead scored" },
//   { icon: Calculator, label: "Loan quote sent" },
//   { icon: FileText, label: "Application started" },
//   { icon: Shield, label: "Documents uploaded" },
//   { icon: CheckCircle2, label: "KYC verified" },
//   { icon: Landmark, label: "Loan sanctioned" },
//   { icon: Wallet, label: "Disbursement complete" },
// ];

// const JOURNEY_2 = [
//   { icon: Target, label: "High-intent lead alert" },
//   { icon: Calculator, label: "EMI calculator used" },
//   { icon: Building2, label: "Property documents" },
//   { icon: Pencil, label: "Digital signing" },
//   { icon: CreditCard, label: "Credit card offer" },
//   { icon: PieChart, label: "Investment portfolio" },
//   { icon: Star, label: "Review request" },
//   { icon: RefreshCw, label: "Refinance offer" },
// ];

// const FAQS = [
//   {
//     q: "What is a banking lead management system?",
//     a: "A banking lead management system is software that captures inquiries for loans, cards, and accounts from every channel, scores and assigns them to the right relationship manager, automates follow-ups, and tracks each lead until it converts into a customer.",
//   },
//   {
//     q: "Which channels can LMSBOTS capture banking leads from?",
//     a: "LMSBOTS captures leads from website forms, mobile apps, branch walk-ins, call centers, partner and DSA referrals, and marketing campaigns, and brings them into a single dashboard with source attribution.",
//   },
//   {
//     q: "Can LMSBOTS help with KYC and document collection?",
//     a: "Yes. You can send secure upload links, track which documents are pending, and move complete applications to your verification queue. Verification decisions and regulatory compliance remain with your institution's own processes.",
//   },
//   {
//     q: "Is it suitable for NBFCs, DSAs, and loan agencies?",
//     a: "Yes. LMSBOTS works for banks, NBFCs, housing finance companies, fintech lenders, and DSAs. Partner-sourced leads can be tracked separately, with performance reports per agent or partner.",
//   },
//   {
//     q: "Can it send EMI reminders and follow-ups on WhatsApp, SMS, and email?",
//     a: "Yes. You can set up trigger-based messages for application follow-ups, document reminders, offer alerts, and EMI due dates across SMS, email, and WhatsApp.",
//   },
//   {
//     q: "How are leads assigned to relationship managers?",
//     a: "Leads can be routed automatically by product, location, language, or RM expertise, and reassigned when an RM is unavailable. Dashboards show response times and conversion rates for each RM.",
//   },
// ];

// const JSON_LD = [
//   {
//     "@context": "https://schema.org",
//     "@type": "SoftwareApplication",
//     name: "LMSBOTS Banking Lead Management System",
//     url: `${SITE_URL}${PATH}`,
//     applicationCategory: "BusinessApplication",
//     applicationSubCategory: "Banking CRM / Loan Lead Management",
//     operatingSystem: "Web, Android, iOS",
//     description: DESCRIPTION,
//     publisher: { "@id": `${SITE_URL}/#organization` },
//     featureList: LEAD_FEATURES.map((f) => f.title),
//   },
//   {
//     "@context": "https://schema.org",
//     "@type": "FAQPage",
//     mainEntity: FAQS.map(({ q, a }) => ({
//       "@type": "Question",
//       name: q,
//       acceptedAnswer: { "@type": "Answer", text: a },
//     })),
//   },
//   {
//     "@context": "https://schema.org",
//     "@type": "BreadcrumbList",
//     itemListElement: [
//       { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
//       { "@type": "ListItem", position: 2, name: "Solutions", item: `${SITE_URL}/solutions` },
//       { "@type": "ListItem", position: 3, name: "Banking & Finance", item: `${SITE_URL}${PATH}` },
//     ],
//   },
// ];

// const fadeUp = {
//   hidden: { opacity: 0, y: 30 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
// };

// const stagger = {
//   hidden: { opacity: 0 },
//   visible: { opacity: 1, transition: { staggerChildren: 0.12 } },
// };

// // Scrolling-journey animation. Respects reduced motion: becomes a static wrapped list.
// const MARQUEE_CSS = `
// .bk-track{display:flex;width:max-content}
// @keyframes bk-left{from{transform:translateX(0)}to{transform:translateX(-50%)}}
// @keyframes bk-right{from{transform:translateX(-50%)}to{transform:translateX(0)}}
// @media (prefers-reduced-motion: no-preference){
//   .bk-left{animation:bk-left 50s linear infinite}
//   .bk-right{animation:bk-right 50s linear infinite}
//   .bk-pause:hover .bk-track,.bk-pause:focus-within .bk-track{animation-play-state:paused}
// }
// @media (prefers-reduced-motion: reduce){
//   .bk-track{width:auto;flex-wrap:wrap;justify-content:center}
//   .bk-dup{display:none}
// }
// `;

// // ---------- Small shared pieces ----------
// const Pill = ({ icon: Icon, children }) => (
//   <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm">
//     {Icon ? <Icon className="h-3.5 w-3.5 text-[#702cb0]" /> : <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#12dfbd]" />}
//     {children}
//   </div>
// );

// const SectionHeading = ({ id, pill, icon, before, highlight, after, text }) => (
//   <div className="mx-auto mb-10 max-w-3xl text-center lg:mb-14">
//     <Pill icon={icon}>{pill}</Pill>
//     <h2
//       id={id}
//       className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
//     >
//       {before}{" "}
//       <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//         {highlight}
//       </span>
//       {after ? ` ${after}` : ""}
//     </h2>
//     {text && (
//       <p className="mx-auto mt-4 max-w-[640px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base">{text}</p>
//     )}
//     <div className="mx-auto mt-6 h-1 w-24 rounded-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f]" />
//   </div>
// );

// const IconTile = ({ icon: Icon, size = "md" }) => (
//   <div
//     className={`inline-flex flex-shrink-0 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white ${
//       size === "lg" ? "h-14 w-14" : "h-12 w-12"
//     }`}
//   >
//     <Icon className={size === "lg" ? "h-7 w-7" : "h-6 w-6"} />
//   </div>
// );

// const CARD =
//   "group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none motion-reduce:hover:translate-y-0";

// const ACCENT_BAR =
//   "absolute left-0 top-0 h-1 w-full origin-left scale-x-0 bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-x-100";

// const JourneyChip = ({ icon: Icon, label, dup = false }) => (
//   <li
//     aria-hidden={dup ? "true" : undefined}
//     className={`${dup ? "bk-dup " : ""}mx-2 inline-flex flex-shrink-0 items-center gap-3 whitespace-nowrap rounded-2xl border border-[#48247f]/10 bg-white px-5 py-3 text-sm font-medium text-[#28194f] shadow-sm sm:text-base`}
//   >
//     <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f1ecfa] text-[#48247f]">
//       <Icon className="h-4 w-4" />
//     </span>
//     {label}
//   </li>
// );

// const Banking = () => {
//   const reduced = useReducedMotion();
//   const item = reduced ? undefined : fadeUp;
//   const group = reduced ? undefined : stagger;
//   const initial = reduced ? false : "hidden";

//   const [activeTab, setActiveTab] = useState("all");
//   const filteredFeatures =
//     activeTab === "all" ? LEAD_FEATURES : LEAD_FEATURES.filter((f) => f.category === activeTab);

//   // Arrow-key navigation between tabs (standard tablist behaviour)
//   const onTabKeyDown = (e, index) => {
//     let next = null;
//     if (e.key === "ArrowRight") next = (index + 1) % FEATURE_TABS.length;
//     if (e.key === "ArrowLeft") next = (index - 1 + FEATURE_TABS.length) % FEATURE_TABS.length;
//     if (e.key === "Home") next = 0;
//     if (e.key === "End") next = FEATURE_TABS.length - 1;
//     if (next === null) return;
//     e.preventDefault();
//     setActiveTab(FEATURE_TABS[next].id);
//     document.getElementById(`bk-tab-${FEATURE_TABS[next].id}`)?.focus();
//   };

//   return (
//     <>
//       <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />
//       <style>{MARQUEE_CSS}</style>

//       <main id="main-content" className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased">
//         {/* ================= HERO ================= */}
//         <section
//           id="banking-hero"
//           aria-labelledby="banking-heading"
//           className="relative isolate w-full overflow-hidden bg-gradient-to-br from-[#fbf7ff] via-white to-[#effbf8]"
//         >
//           <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
//           <div className="pointer-events-none absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />

//           <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-24 sm:gap-12 sm:px-10 sm:pb-16 sm:pt-28 lg:grid-cols-2 lg:gap-14 lg:px-14 lg:pb-20 lg:pt-32 xl:px-20">
//             <motion.div
//               initial={initial}
//               animate="visible"
//               variants={group}
//               className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
//             >
//               <motion.div variants={item}>
//                 <Pill icon={Zap}>Lead Management for Banking &amp; Finance</Pill>
//               </motion.div>

//               <motion.h1
//                 id="banking-heading"
//                 variants={item}
//                 className="text-balance text-[28px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
//               >
//                 Turn every banking lead into a{" "}
//                 <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//                   valued customer
//                 </span>
//               </motion.h1>

//               <motion.p
//                 variants={item}
//                 className="mx-auto mt-4 max-w-[540px] text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base lg:mx-0 lg:text-[17px]"
//               >
//                 Capture, qualify, and convert banking leads with intelligent automation. From loan
//                 inquiries to wealth management, manage your entire financial services pipeline on one
//                 platform.
//               </motion.p>

//               <motion.div
//                 variants={item}
//                 className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
//               >
//                 <Link
//                   to="/contact"
//                   className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//                 >
//                   Request a Demo
//                   <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
//                 </Link>
//                 <Link
//                   to="/features"
//                   className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-6 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//                 >
//                   Explore Features
//                 </Link>
//               </motion.div>

//               <motion.ul
//                 variants={item}
//                 className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 lg:justify-start"
//               >
//                 {HERO_POINTS.map((p) => (
//                   <li key={p} className="inline-flex items-center gap-2 text-xs font-medium text-[#3b2a63] sm:text-sm">
//                     <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" strokeWidth={2.5} />
//                     {p}
//                   </li>
//                 ))}
//               </motion.ul>
//             </motion.div>

//             <motion.div
//               initial={reduced ? false : { opacity: 0, x: 40 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.8, ease: "easeOut" }}
//               className="group relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none"
//             >
//               <div className="absolute inset-x-3 bottom-6 top-3 translate-x-3 translate-y-3 rounded-3xl bg-gradient-to-br from-[#48247f] to-[#702cb0] transition-transform duration-500 group-hover:translate-x-4 group-hover:translate-y-4 motion-reduce:transition-none" />
//               <div className="relative rounded-2xl bg-white p-2 shadow-2xl ring-1 ring-[#48247f]/10">
//                 <img
//                   src={Bank}
//                   alt="LMSBOTS banking lead management dashboard showing loan leads, KYC status and RM assignments"
//                   width="1200"
//                   height="800"
//                   fetchpriority="high"
//                   decoding="async"
//                   className="h-auto w-full rounded-xl border border-[#48247f]/10 object-cover"
//                 />
//               </div>
//             </motion.div>
//           </div>
//         </section>

//         {/* ================= FEATURES WITH TABS ================= */}
//         <section
//           id="banking-features"
//           aria-labelledby="banking-features-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="banking-features-heading"
//               pill="Complete Banking Solution"
//               icon={Settings}
//               before="How LMSBOTS helps"
//               highlight="banks & financial institutions"
//               text="Everything you need to capture, nurture, and convert banking leads, all in one platform."
//             />

//             <div
//               role="tablist"
//               aria-label="Filter banking features"
//               className="-mx-4 mb-8 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] sm:mx-0 sm:flex-wrap sm:justify-center sm:overflow-visible sm:px-0 [&::-webkit-scrollbar]:hidden"
//             >
//               {FEATURE_TABS.map((tab, i) => {
//                 const active = activeTab === tab.id;
//                 const Icon = tab.icon;
//                 return (
//                   <button
//                     key={tab.id}
//                     id={`bk-tab-${tab.id}`}
//                     type="button"
//                     role="tab"
//                     aria-selected={active}
//                     aria-controls="bk-panel"
//                     tabIndex={active ? 0 : -1}
//                     onClick={() => setActiveTab(tab.id)}
//                     onKeyDown={(e) => onTabKeyDown(e, i)}
//                     className={`inline-flex min-h-[44px] flex-shrink-0 items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-xs font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#702cb0] focus-visible:ring-offset-2 sm:text-sm ${
//                       active
//                         ? "border-transparent bg-gradient-to-r from-[#48247f] to-[#702cb0] text-white shadow-lg shadow-[#48247f]/25"
//                         : "border-[#48247f]/15 bg-white text-slate-700 hover:border-[#702cb0]/50 hover:text-[#48247f]"
//                     }`}
//                   >
//                     <Icon className="h-4 w-4" />
//                     {tab.label}
//                   </button>
//                 );
//               })}
//             </div>

//             <ul
//               id="bk-panel"
//               role="tabpanel"
//               aria-labelledby={`bk-tab-${activeTab}`}
//               className="grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-8"
//             >
//               {filteredFeatures.map((f) => (
//                 <li key={f.title} className={`${CARD} flex gap-5 p-6 sm:p-8`}>
//                   <div className={ACCENT_BAR} />
//                   <IconTile icon={f.icon} />
//                   <div className="min-w-0">
//                     <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f] sm:text-xl">{f.title}</h3>
//                     <p className="text-sm leading-[1.75] text-slate-700">{f.content}</p>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </section>

//         {/* ================= PRODUCTS ================= */}
//         <section
//           id="banking-products"
//           aria-labelledby="banking-products-heading"
//           className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -left-24 -top-24 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="banking-products-heading"
//               pill="Financial Products"
//               before="Manage leads across"
//               highlight="all banking products"
//               text="Specialized workflows for every financial service you offer."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
//             >
//               {PRODUCTS.map((p) => (
//                 <motion.li key={p.title} variants={item} className={`${CARD} flex items-center gap-4 p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <IconTile icon={p.icon} size="lg" />
//                   <div className="min-w-0">
//                     <h3 className="text-lg font-medium tracking-tight text-[#28194f]">{p.title}</h3>
//                     <p className="mt-1 text-sm leading-snug text-slate-600">{p.desc}</p>
//                   </div>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= WHO IT'S FOR (new content) ================= */}
//         <section
//           id="banking-audience"
//           aria-labelledby="banking-audience-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="banking-audience-heading"
//               pill="Who It's For"
//               icon={Users}
//               before="Built for every"
//               highlight="lending and finance team"
//               text="Whether you run a branch network or a digital-first lending app, LMSBOTS adapts to how your teams source and close leads."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
//             >
//               {AUDIENCE.map((a) => (
//                 <motion.li key={a.title} variants={item} className={`${CARD} p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-4">
//                     <IconTile icon={a.icon} />
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{a.title}</h3>
//                   <p className="text-sm leading-[1.7] text-slate-700">{a.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= WORKFLOW ================= */}
//         <section
//           id="banking-workflow"
//           aria-labelledby="banking-workflow-heading"
//           className="relative isolate w-full overflow-hidden border-t border-[#48247f]/10 bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -bottom-24 -right-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="banking-workflow-heading"
//               pill="Lead Management Workflow"
//               icon={RefreshCw}
//               before="From"
//               highlight="lead to customer"
//               after="in 4 simple steps"
//               text="Automated workflows that guide prospects through your banking sales pipeline."
//             />

//             <motion.ol
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 lg:gap-6"
//             >
//               {WORKFLOWS.map((w, i) => (
//                 <motion.li key={w.title} variants={item} className={`${CARD} h-full p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-5 flex items-start justify-between">
//                     <IconTile icon={w.icon} />
//                     <span className="text-3xl font-light leading-none text-[#48247f]/15 transition-colors duration-300 group-hover:text-[#12dfbd]">
//                       {String(i + 1).padStart(2, "0")}
//                     </span>
//                   </div>
//                   <h3 className="mb-4 text-lg font-medium tracking-tight text-[#28194f]">{w.title}</h3>
//                   <ul className="space-y-2.5">
//                     {w.steps.map((s) => (
//                       <li key={s} className="flex items-start gap-2.5 text-sm text-slate-700">
//                         <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#0f9d86]" strokeWidth={2.5} />
//                         <span>{s}</span>
//                       </li>
//                     ))}
//                   </ul>
//                 </motion.li>
//               ))}
//             </motion.ol>
//           </div>
//         </section>

//         {/* ================= BENEFITS ================= */}
//         <section
//           id="banking-benefits"
//           aria-labelledby="banking-benefits-heading"
//           className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="banking-benefits-heading"
//               pill="Key Benefits"
//               icon={TrendingUp}
//               before="Why banking institutions choose"
//               highlight="LMSBOTS"
//               text="Close more loans faster with automation, clear ownership, and real-time insight."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
//             >
//               {BENEFITS.map((b) => (
//                 <motion.li key={b.title} variants={item} className={`${CARD} p-6`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-4">
//                     <IconTile icon={b.icon} />
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{b.title}</h3>
//                   <p className="text-sm leading-[1.7] text-slate-700">{b.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= CORE FEATURES ================= */}
//         <section
//           id="banking-core"
//           aria-labelledby="banking-core-heading"
//           className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -right-24 -top-24 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="banking-core-heading"
//               pill="Core Capabilities"
//               before="Powerful features for"
//               highlight="banking success"
//               text="Everything you need to streamline lead management and close more loans efficiently."
//             />

//             <motion.ul
//               variants={group}
//               initial={initial}
//               whileInView="visible"
//               viewport={{ once: true, margin: "-80px" }}
//               className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
//             >
//               {CORE_FEATURES.map((f) => (
//                 <motion.li key={f.title} variants={item} className={`${CARD} p-6 sm:p-7`}>
//                   <div className={ACCENT_BAR} />
//                   <div className="mb-4">
//                     <IconTile icon={f.icon} />
//                   </div>
//                   <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
//                   <p className="text-sm leading-[1.7] text-slate-700">{f.desc}</p>
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </div>
//         </section>

//         {/* ================= LEAD JOURNEY ================= */}
//         <section
//           id="banking-journey"
//           aria-labelledby="banking-journey-heading"
//           className="relative w-full overflow-hidden bg-white py-14 sm:py-16 lg:py-24"
//         >
//           <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="banking-journey-heading"
//               pill="Lead Journey"
//               before="The complete"
//               highlight="banking lead journey"
//               text="See how leads move through your automated pipeline, from first inquiry to loan disbursement."
//             />
//           </div>

//           <div className="bk-pause relative space-y-4" aria-label="Examples of stages in the banking lead journey" role="group">
//             <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent sm:w-32" />
//             <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent sm:w-32" />

//             {[
//               { list: JOURNEY_1, dir: "bk-left" },
//               { list: JOURNEY_2, dir: "bk-right" },
//             ].map(({ list, dir }) => (
//               <div key={dir} className="overflow-hidden">
//                 <ul className={`bk-track ${dir}`}>
//                   {list.map((j) => (
//                     <JourneyChip key={j.label} {...j} />
//                   ))}
//                   {/* Duplicate set makes the loop seamless; hidden from assistive tech and reduced-motion users */}
//                   {list.map((j) => (
//                     <JourneyChip key={`dup-${j.label}`} dup {...j} />
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </section>

//         {/* ================= FAQ (new content) ================= */}
//         <section
//           id="banking-faq"
//           aria-labelledby="banking-faq-heading"
//           className="relative isolate w-full overflow-hidden bg-gradient-to-br from-[#fbf7ff] via-white to-[#effbf8] py-14 sm:py-16 lg:py-24"
//         >
//           <div className="pointer-events-none absolute -bottom-24 -left-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
//           <div className="mx-auto w-full max-w-[900px] px-4 sm:px-10 lg:px-14">
//             <SectionHeading
//               id="banking-faq-heading"
//               pill="FAQ"
//               before="Banking lead management"
//               highlight="questions answered"
//             />

//             <div className="space-y-4">
//               {FAQS.map(({ q, a }, i) => (
//                 <details
//                   key={q}
//                   open={i === 0}
//                   className="group overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-14px_rgba(72,36,127,0.25)] transition-colors open:border-[#702cb0]/40"
//                 >
//                   <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left text-[15px] font-medium leading-snug text-[#28194f] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#702cb0] sm:px-6 sm:text-base [&::-webkit-details-marker]:hidden">
//                     <h3 className="flex-1 text-[15px] font-medium sm:text-base">{q}</h3>
//                     <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-open:rotate-180 group-open:bg-[#12dfbd] group-open:text-[#102b37]">
//                       <ChevronDown className="h-5 w-5" />
//                     </span>
//                   </summary>
//                   <p className="px-5 pb-6 text-sm leading-[1.75] text-slate-700 sm:px-6 sm:text-[15px]">{a}</p>
//                 </details>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* ================= CLOSING CTA (new content) ================= */}
//         <section
//           aria-labelledby="banking-cta-heading"
//           className="w-full bg-white px-4 py-10 sm:px-10 sm:py-12 lg:px-14 lg:py-16"
//         >
//           <div className="relative isolate mx-auto w-full max-w-[1300px] overflow-hidden rounded-[1.5rem] border border-[#48247f]/10 bg-gradient-to-br from-[#f1ecfa] via-white to-[#e3faf5] px-5 py-12 text-center shadow-[0_20px_60px_-20px_rgba(72,36,127,0.25)] sm:rounded-[2rem] sm:px-12 sm:py-16">
//             <div className="pointer-events-none absolute -right-20 -top-20 -z-10 h-72 w-72 rounded-full bg-[#12dfbd]/20 blur-3xl" />
//             <h2
//               id="banking-cta-heading"
//               className="mx-auto max-w-2xl text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px]"
//             >
//               Ready to close{" "}
//               <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//                 more loans, faster?
//               </span>
//             </h2>
//             <p className="mx-auto mt-4 max-w-[560px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base">
//               See how LMSBOTS fits your lending workflow. We'll walk you through lead capture, RM
//               assignment, KYC follow-ups, and reporting on a live demo.
//             </p>
//             <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
//               <Link
//                 to="/contact"
//                 className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-7 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//               >
//                 Request a Demo
//                 <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
//               </Link>
//               <Link
//                 to="/pricing"
//                 className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-7 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
//               >
//                 View Pricing
//               </Link>
//             </div>
//           </div>
//         </section>
//       </main>
//     </>
//   );
// };

// export default Banking;











import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import {
  ArrowRight,
  Bell,
  MessageCircle,
  Calendar,
  Shield,
  BarChart3,
  Users,
  TrendingUp,
  Zap,
  Settings,
  CheckCircle2,
  FileText,
  UserCheck,
  Rocket,
  CreditCard,
  Building2,
  PiggyBank,
  Briefcase,
  Landmark,
  Wallet,
  LineChart,
  PieChart,
  Lock,
  Timer,
  Calculator,
  Target,
  ChevronDown,
  Search,
  Smartphone,
  Pencil,
  Star,
  RefreshCw,
} from "lucide-react";
import Bank from "../../assets/banking.jpg";
// NOTE: adjust this path to wherever Seo.js lives in your project
import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";
import { ROUTES } from "../../seoData";

const PATH = "/solutions/banking-finance";
const TITLE = ROUTES[PATH].title;
const DESCRIPTION = ROUTES[PATH].description;

// ---------- Static content (outside the component so it isn't rebuilt on every render) ----------
const HERO_POINTS = ["Loan lead scoring", "KYC workflows", "EMI reminders"];

const FEATURE_TABS = [
  { id: "all", label: "All Features", icon: Zap },
  { id: "lead", label: "Lead Capture", icon: Users },
  { id: "nurturing", label: "Nurturing", icon: MessageCircle },
  { id: "quote", label: "Loan Quotes", icon: Calculator },
  { id: "compliance", label: "KYC & Compliance", icon: Shield },
  { id: "distribution", label: "RM Assignment", icon: UserCheck },
  { id: "cross-sell", label: "Cross-sell", icon: PieChart },
];

const LEAD_FEATURES = [
  {
    title: "Intelligent Lead Capture & Scoring",
    content:
      "Capture leads from websites, apps, branches, call centers, and partners. Score them on income, loan amount, product interest, and engagement so your team calls the highest-intent prospects first.",
    icon: CreditCard,
    category: "lead",
  },
  {
    title: "Automated Loan Application Nurturing",
    content:
      "Guide leads through the loan journey with SMS, email, and WhatsApp: welcome messages, document checklists, and status updates. Inactive or dropped applications get follow-ups automatically.",
    icon: FileText,
    category: "nurturing",
  },
  {
    title: "Instant Loan Quote & Eligibility Checker",
    content:
      "Generate and send personalized loan quotes, EMI details, and eligibility summaries instantly, with rates, tenure options, and fee breakdowns your team defines.",
    icon: Calculator,
    category: "quote",
  },
  {
    title: "Document Collection & KYC Workflow",
    content:
      "Share secure upload links, track which documents are pending, and move applications to your verification queue faster, while your team keeps control of approvals and compliance checks.",
    icon: Shield,
    category: "compliance",
  },
  {
    title: "Lead Distribution & RM Assignment",
    content:
      "Assign leads to the right relationship manager by product, location, or expertise. Shorten response time and review each RM's performance in one dashboard.",
    icon: Users,
    category: "distribution",
  },
  {
    title: "Cross-sell & Upsell Automation",
    content:
      "Spot opportunities in existing customer data and recommend credit cards, insurance, and investment products through personalized campaigns.",
    icon: PieChart,
    category: "cross-sell",
  },
];

const PRODUCTS = [
  { icon: Building2, title: "Home Loans", desc: "Purchase, construction, and renovation leads" },
  { icon: Briefcase, title: "Personal Loans", desc: "Fast-moving, high-volume inquiries" },
  { icon: Landmark, title: "Business Loans", desc: "Working capital and expansion financing" },
  { icon: CreditCard, title: "Credit Cards", desc: "Rewards, travel, and premium card leads" },
  { icon: PiggyBank, title: "Savings Accounts", desc: "Account opening and onboarding follow-ups" },
  { icon: Wallet, title: "Wealth Management", desc: "Investment and portfolio inquiries" },
];

const AUDIENCE = [
  {
    icon: Landmark,
    title: "Banks & cooperative banks",
    desc: "Bring branch, digital, and call-center leads into one pipeline with clear RM ownership.",
  },
  {
    icon: Building2,
    title: "NBFCs & housing finance",
    desc: "Handle high loan-inquiry volumes with automated follow-ups and document tracking.",
  },
  {
    icon: Smartphone,
    title: "Fintech lenders",
    desc: "Connect app and web sign-ups to scoring, nurturing, and quick quote delivery.",
  },
  {
    icon: UserCheck,
    title: "DSAs & loan agencies",
    desc: "Track partner-sourced leads, agent performance, and payout-ready conversion data.",
  },
];

const WORKFLOWS = [
  {
    icon: UserCheck,
    title: "Lead Capture",
    steps: ["Website forms", "Mobile app", "Branch walk-ins", "Call center", "Partner referrals"],
  },
  {
    icon: Calculator,
    title: "Eligibility & Quote",
    steps: ["Lead scoring", "Income details", "Loan quote generation", "EMI calculator", "Offer delivery"],
  },
  {
    icon: Shield,
    title: "Documentation & KYC",
    steps: ["Document request", "Secure upload", "Pending-document tracking", "Verification queue", "Approval handoff"],
  },
  {
    icon: Rocket,
    title: "Disbursement & Onboarding",
    steps: ["Loan sanction", "Digital signing", "Disbursement update", "Welcome message", "Cross-sell offers"],
  },
];

const BENEFITS = [
  {
    icon: Timer,
    title: "Faster loan processing",
    desc: "Automated document requests and status updates replace manual chasing.",
  },
  {
    icon: Target,
    title: "Better lead prioritization",
    desc: "Scoring surfaces high-intent applicants so RMs contact them first.",
  },
  {
    icon: TrendingUp,
    title: "Smarter acquisition spend",
    desc: "See which channels and partners bring qualified applicants, and invest accordingly.",
  },
  {
    icon: Lock,
    title: "Audit-ready records",
    desc: "Every call, message, and document is logged against the lead for easy review.",
  },
];

const CORE_FEATURES = [
  { icon: Bell, title: "Instant Loan Alerts", desc: "Notify leads about offers and interest rate changes in seconds." },
  { icon: MessageCircle, title: "Automated Follow-ups", desc: "Smart sequences re-engage applicants who abandoned an application." },
  { icon: Calendar, title: "Payment Reminders", desc: "Send EMI reminders and overdue notifications on schedule." },
  { icon: Shield, title: "Secure Document Collection", desc: "Collect KYC documents through secure upload links." },
  { icon: LineChart, title: "Lead Scoring", desc: "Rank applicants by profile and engagement to focus effort." },
  { icon: BarChart3, title: "Analytics Dashboard", desc: "Track conversions, ROI, and RM performance in real time." },
];

const JOURNEY_1 = [
  { icon: Search, label: "Website inquiry" },
  { icon: LineChart, label: "Lead scored" },
  { icon: Calculator, label: "Loan quote sent" },
  { icon: FileText, label: "Application started" },
  { icon: Shield, label: "Documents uploaded" },
  { icon: CheckCircle2, label: "KYC verified" },
  { icon: Landmark, label: "Loan sanctioned" },
  { icon: Wallet, label: "Disbursement complete" },
];

const JOURNEY_2 = [
  { icon: Target, label: "High-intent lead alert" },
  { icon: Calculator, label: "EMI calculator used" },
  { icon: Building2, label: "Property documents" },
  { icon: Pencil, label: "Digital signing" },
  { icon: CreditCard, label: "Credit card offer" },
  { icon: PieChart, label: "Investment portfolio" },
  { icon: Star, label: "Review request" },
  { icon: RefreshCw, label: "Refinance offer" },
];

const FAQS = [
  {
    q: "What is a banking lead management system?",
    a: "A banking lead management system is software that captures inquiries for loans, cards, and accounts from every channel, scores and assigns them to the right relationship manager, automates follow-ups, and tracks each lead until it converts into a customer.",
  },
  {
    q: "Which channels can LMSBOTS capture banking leads from?",
    a: "LMSBOTS captures leads from website forms, mobile apps, branch walk-ins, call centers, partner and DSA referrals, and marketing campaigns, and brings them into a single dashboard with source attribution.",
  },
  {
    q: "Can LMSBOTS help with KYC and document collection?",
    a: "Yes. You can send secure upload links, track which documents are pending, and move complete applications to your verification queue. Verification decisions and regulatory compliance remain with your institution's own processes.",
  },
  {
    q: "Is it suitable for NBFCs, DSAs, and loan agencies?",
    a: "Yes. LMSBOTS works for banks, NBFCs, housing finance companies, fintech lenders, and DSAs. Partner-sourced leads can be tracked separately, with performance reports per agent or partner.",
  },
  {
    q: "Can it send EMI reminders and follow-ups on WhatsApp, SMS, and email?",
    a: "Yes. You can set up trigger-based messages for application follow-ups, document reminders, offer alerts, and EMI due dates across SMS, email, and WhatsApp.",
  },
  {
    q: "How are leads assigned to relationship managers?",
    a: "Leads can be routed automatically by product, location, language, or RM expertise, and reassigned when an RM is unavailable. Dashboards show response times and conversion rates for each RM.",
  },
];

const JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "LMSBOTS Banking Lead Management System",
    url: `${SITE_URL}${PATH}`,
    applicationCategory: "BusinessApplication",
    applicationSubCategory: "Banking CRM / Loan Lead Management",
    operatingSystem: "Web, Android, iOS",
    description: DESCRIPTION,
    publisher: { "@id": `${SITE_URL}/#organization` },
    featureList: LEAD_FEATURES.map((f) => f.title),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: "Solutions", item: `${SITE_URL}/solutions` },
      { "@type": "ListItem", position: 3, name: "Banking & Finance", item: `${SITE_URL}${PATH}` },
    ],
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const stagger = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.12 } },
};

// Scrolling-journey animation. Respects reduced motion: becomes a static wrapped list.
const MARQUEE_CSS = `
.bk-track{display:flex;width:max-content}
@keyframes bk-left{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@keyframes bk-right{from{transform:translateX(-50%)}to{transform:translateX(0)}}
@media (prefers-reduced-motion: no-preference){
  .bk-left{animation:bk-left 50s linear infinite}
  .bk-right{animation:bk-right 50s linear infinite}
  .bk-pause:hover .bk-track,.bk-pause:focus-within .bk-track{animation-play-state:paused}
}
@media (prefers-reduced-motion: reduce){
  .bk-track{width:auto;flex-wrap:wrap;justify-content:center}
  .bk-dup{display:none}
}
`;

// ---------- Small shared pieces ----------
const Pill = ({ icon: Icon, children }) => (
  <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm">
    {Icon ? <Icon className="h-3.5 w-3.5 text-[#702cb0]" /> : <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#12dfbd]" />}
    {children}
  </div>
);

const SectionHeading = ({ id, pill, icon, before, highlight, after, text }) => (
  <div className="mx-auto mb-10 max-w-3xl text-center lg:mb-14">
    <Pill icon={icon}>{pill}</Pill>
    <h2
      id={id}
      className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
    >
      {before}{" "}
      <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
        {highlight}
      </span>
      {after ? ` ${after}` : ""}
    </h2>
    {text && (
      <p className="mx-auto mt-4 max-w-[640px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base">{text}</p>
    )}
    <div className="mx-auto mt-6 h-1 w-24 rounded-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f]" />
  </div>
);

const IconTile = ({ icon: Icon, size = "md" }) => (
  <div
    className={`inline-flex flex-shrink-0 items-center justify-center rounded-xl bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white ${
      size === "lg" ? "h-14 w-14" : "h-12 w-12"
    }`}
  >
    <Icon className={size === "lg" ? "h-7 w-7" : "h-6 w-6"} />
  </div>
);

const CARD =
  "group relative overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-12px_rgba(72,36,127,0.25)] transition-all duration-300 hover:-translate-y-1 hover:border-[#702cb0]/40 hover:shadow-[0_24px_48px_-12px_rgba(72,36,127,0.4)] motion-reduce:transition-none motion-reduce:hover:translate-y-0";

const ACCENT_BAR =
  "absolute left-0 top-0 h-1 w-full origin-left scale-x-0 bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f] transition-transform duration-500 ease-out group-hover:scale-x-100";

const JourneyChip = ({ icon: Icon, label, dup = false }) => (
  <li
    aria-hidden={dup ? "true" : undefined}
    className={`${dup ? "bk-dup " : ""}mx-2 inline-flex flex-shrink-0 items-center gap-3 whitespace-nowrap rounded-2xl border border-[#48247f]/10 bg-white px-5 py-3 text-sm font-medium text-[#28194f] shadow-sm sm:text-base`}
  >
    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f1ecfa] text-[#48247f]">
      <Icon className="h-4 w-4" />
    </span>
    {label}
  </li>
);

const Banking = () => {
  const reduced = useReducedMotion();
  const item = reduced ? undefined : fadeUp;
  const group = reduced ? undefined : stagger;
  const initial = reduced ? false : "hidden";

  const [activeTab, setActiveTab] = useState("all");
  const filteredFeatures =
    activeTab === "all" ? LEAD_FEATURES : LEAD_FEATURES.filter((f) => f.category === activeTab);

  // Arrow-key navigation between tabs (standard tablist behaviour)
  const onTabKeyDown = (e, index) => {
    let next = null;
    if (e.key === "ArrowRight") next = (index + 1) % FEATURE_TABS.length;
    if (e.key === "ArrowLeft") next = (index - 1 + FEATURE_TABS.length) % FEATURE_TABS.length;
    if (e.key === "Home") next = 0;
    if (e.key === "End") next = FEATURE_TABS.length - 1;
    if (next === null) return;
    e.preventDefault();
    setActiveTab(FEATURE_TABS[next].id);
    document.getElementById(`bk-tab-${FEATURE_TABS[next].id}`)?.focus();
  };

  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />
      <style>{MARQUEE_CSS}</style>

      <div className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased">
        {/* ================= HERO ================= */}
        <section
          id="banking-hero"
          aria-labelledby="banking-heading"
          className="relative isolate w-full overflow-hidden bg-gradient-to-br from-[#fbf7ff] via-white to-[#effbf8]"
        >
          <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />

          <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-24 sm:gap-12 sm:px-10 sm:pb-16 sm:pt-28 lg:grid-cols-2 lg:gap-14 lg:px-14 lg:pb-20 lg:pt-32 xl:px-20">
            <motion.div
              initial={initial}
              animate="visible"
              variants={group}
              className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
            >
              <motion.div variants={item}>
                <Pill icon={Zap}>Lead Management for Banking &amp; Finance</Pill>
              </motion.div>

              <motion.h1
                id="banking-heading"
                variants={item}
                className="text-balance text-[28px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
              >
                Turn every banking lead into a{" "}
                <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                  valued customer
                </span>
              </motion.h1>

              <motion.p
                variants={item}
                className="mx-auto mt-4 max-w-[540px] text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base lg:mx-0 lg:text-[17px]"
              >
                Capture, qualify, and convert banking leads with intelligent automation. From loan
                inquiries to wealth management, manage your entire financial services pipeline on one
                platform.
              </motion.p>

              <motion.div
                variants={item}
                className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
              >
                <Link
                  to="/contact"
                  className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Request a Demo
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
                <Link
                  to="/features"
                  className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-6 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Explore Features
                </Link>
              </motion.div>

              <motion.ul
                variants={item}
                className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 lg:justify-start"
              >
                {HERO_POINTS.map((p) => (
                  <li key={p} className="inline-flex items-center gap-2 text-xs font-medium text-[#3b2a63] sm:text-sm">
                    <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" strokeWidth={2.5} />
                    {p}
                  </li>
                ))}
              </motion.ul>
            </motion.div>

            {/* Hero image — simple & clean, matching Healthcare */}
            <motion.div
              initial={reduced ? false : { opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none"
            >
              {/* Plain tinted block sits below the image */}
              <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#e3faf5]" />
              <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
                <img
                  src={Bank}
                  alt="LMSBOTS banking lead management dashboard showing loan leads, KYC status and RM assignments"
                  width="1200"
                  height="800"
                  fetchpriority="high"
                  decoding="async"
                  className="h-auto w-full rounded-xl border border-slate-200 object-cover"
                />
              </div>
            </motion.div>
          </div>
        </section>

        {/* ================= FEATURES WITH TABS ================= */}
        <section
          id="banking-features"
          aria-labelledby="banking-features-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="banking-features-heading"
              pill="Complete Banking Solution"
              icon={Settings}
              before="How LMSBOTS helps"
              highlight="banks & financial institutions"
              text="Everything you need to capture, nurture, and convert banking leads, all in one platform."
            />

            <div
              role="tablist"
              aria-label="Filter banking features"
              className="-mx-4 mb-8 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] sm:mx-0 sm:flex-wrap sm:justify-center sm:overflow-visible sm:px-0 [&::-webkit-scrollbar]:hidden"
            >
              {FEATURE_TABS.map((tab, i) => {
                const active = activeTab === tab.id;
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    id={`bk-tab-${tab.id}`}
                    type="button"
                    role="tab"
                    aria-selected={active}
                    aria-controls="bk-panel"
                    tabIndex={active ? 0 : -1}
                    onClick={() => setActiveTab(tab.id)}
                    onKeyDown={(e) => onTabKeyDown(e, i)}
                    className={`inline-flex min-h-[44px] flex-shrink-0 items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-xs font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#702cb0] focus-visible:ring-offset-2 sm:text-sm ${
                      active
                        ? "border-transparent bg-gradient-to-r from-[#48247f] to-[#702cb0] text-white shadow-lg shadow-[#48247f]/25"
                        : "border-[#48247f]/15 bg-white text-slate-700 hover:border-[#702cb0]/50 hover:text-[#48247f]"
                    }`}
                  >
                    <Icon className="h-4 w-4" />
                    {tab.label}
                  </button>
                );
              })}
            </div>

            <ul
              id="bk-panel"
              role="tabpanel"
              aria-labelledby={`bk-tab-${activeTab}`}
              className="grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-8"
            >
              {filteredFeatures.map((f) => (
                <li key={f.title} className={`${CARD} flex gap-5 p-6 sm:p-8`}>
                  <div className={ACCENT_BAR} />
                  <IconTile icon={f.icon} />
                  <div className="min-w-0">
                    <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f] sm:text-xl">{f.title}</h3>
                    <p className="text-sm leading-[1.75] text-slate-700">{f.content}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* ================= PRODUCTS ================= */}
        <section
          id="banking-products"
          aria-labelledby="banking-products-heading"
          className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -left-24 -top-24 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="banking-products-heading"
              pill="Financial Products"
              before="Manage leads across"
              highlight="all banking products"
              text="Specialized workflows for every financial service you offer."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
            >
              {PRODUCTS.map((p) => (
                <motion.li key={p.title} variants={item} className={`${CARD} flex items-center gap-4 p-6`}>
                  <div className={ACCENT_BAR} />
                  <IconTile icon={p.icon} size="lg" />
                  <div className="min-w-0">
                    <h3 className="text-lg font-medium tracking-tight text-[#28194f]">{p.title}</h3>
                    <p className="mt-1 text-sm leading-snug text-slate-600">{p.desc}</p>
                  </div>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= WHO IT'S FOR ================= */}
        <section
          id="banking-audience"
          aria-labelledby="banking-audience-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="banking-audience-heading"
              pill="Who It's For"
              icon={Users}
              before="Built for every"
              highlight="lending and finance team"
              text="Whether you run a branch network or a digital-first lending app, LMSBOTS adapts to how your teams source and close leads."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
            >
              {AUDIENCE.map((a) => (
                <motion.li key={a.title} variants={item} className={`${CARD} p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={a.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{a.title}</h3>
                  <p className="text-sm leading-[1.7] text-slate-700">{a.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= WORKFLOW ================= */}
        <section
          id="banking-workflow"
          aria-labelledby="banking-workflow-heading"
          className="relative isolate w-full overflow-hidden border-t border-[#48247f]/10 bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -bottom-24 -right-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="banking-workflow-heading"
              pill="Lead Management Workflow"
              icon={RefreshCw}
              before="From"
              highlight="lead to customer"
              after="in 4 simple steps"
              text="Automated workflows that guide prospects through your banking sales pipeline."
            />

            <motion.ol
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 lg:gap-6"
            >
              {WORKFLOWS.map((w, i) => (
                <motion.li key={w.title} variants={item} className={`${CARD} h-full p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-5 flex items-start justify-between">
                    <IconTile icon={w.icon} />
                    <span className="text-3xl font-light leading-none text-[#48247f]/15 transition-colors duration-300 group-hover:text-[#12dfbd]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mb-4 text-lg font-medium tracking-tight text-[#28194f]">{w.title}</h3>
                  <ul className="space-y-2.5">
                    {w.steps.map((s) => (
                      <li key={s} className="flex items-start gap-2.5 text-sm text-slate-700">
                        <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#0f9d86]" strokeWidth={2.5} />
                        <span>{s}</span>
                      </li>
                    ))}
                  </ul>
                </motion.li>
              ))}
            </motion.ol>
          </div>
        </section>

        {/* ================= BENEFITS ================= */}
        <section
          id="banking-benefits"
          aria-labelledby="banking-benefits-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="banking-benefits-heading"
              pill="Key Benefits"
              icon={TrendingUp}
              before="Why banking institutions choose"
              highlight="LMSBOTS"
              text="Close more loans faster with automation, clear ownership, and real-time insight."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
            >
              {BENEFITS.map((b) => (
                <motion.li key={b.title} variants={item} className={`${CARD} p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={b.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{b.title}</h3>
                  <p className="text-sm leading-[1.7] text-slate-700">{b.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= CORE FEATURES ================= */}
        <section
          id="banking-core"
          aria-labelledby="banking-core-heading"
          className="relative isolate w-full overflow-hidden bg-[#f6f3fc] py-14 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -right-24 -top-24 -z-10 h-96 w-96 rounded-full bg-[#702cb0]/10 blur-3xl" />
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="banking-core-heading"
              pill="Core Capabilities"
              before="Powerful features for"
              highlight="banking success"
              text="Everything you need to streamline lead management and close more loans efficiently."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
            >
              {CORE_FEATURES.map((f) => (
                <motion.li key={f.title} variants={item} className={`${CARD} p-6 sm:p-7`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={f.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
                  <p className="text-sm leading-[1.7] text-slate-700">{f.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= LEAD JOURNEY ================= */}
        <section
          id="banking-journey"
          aria-labelledby="banking-journey-heading"
          className="relative w-full overflow-hidden bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="banking-journey-heading"
              pill="Lead Journey"
              before="The complete"
              highlight="banking lead journey"
              text="See how leads move through your automated pipeline, from first inquiry to loan disbursement."
            />
          </div>

          <div className="bk-pause relative space-y-4" aria-label="Examples of stages in the banking lead journey" role="group">
            <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent sm:w-32" />
            <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent sm:w-32" />

            {[
              { list: JOURNEY_1, dir: "bk-left" },
              { list: JOURNEY_2, dir: "bk-right" },
            ].map(({ list, dir }) => (
              <div key={dir} className="overflow-hidden">
                <ul className={`bk-track ${dir}`}>
                  {list.map((j) => (
                    <JourneyChip key={j.label} {...j} />
                  ))}
                  {/* Duplicate set makes the loop seamless; hidden from assistive tech and reduced-motion users */}
                  {list.map((j) => (
                    <JourneyChip key={`dup-${j.label}`} dup {...j} />
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* ================= FAQ ================= */}
        <section
          id="banking-faq"
          aria-labelledby="banking-faq-heading"
          className="relative isolate w-full overflow-hidden bg-gradient-to-br from-[#fbf7ff] via-white to-[#effbf8] py-14 sm:py-16 lg:py-24"
        >
          <div className="pointer-events-none absolute -bottom-24 -left-24 -z-10 h-96 w-96 rounded-full bg-[#12dfbd]/15 blur-3xl" />
          <div className="mx-auto w-full max-w-[900px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="banking-faq-heading"
              pill="FAQ"
              before="Banking lead management"
              highlight="questions answered"
            />

            <div className="space-y-4">
              {FAQS.map(({ q, a }, i) => (
                <details
                  key={q}
                  open={i === 0}
                  className="group overflow-hidden rounded-2xl border border-[#48247f]/10 bg-white shadow-[0_8px_30px_-14px_rgba(72,36,127,0.25)] transition-colors open:border-[#702cb0]/40"
                >
                  <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left text-[15px] font-medium leading-snug text-[#28194f] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#702cb0] sm:px-6 sm:text-base [&::-webkit-details-marker]:hidden">
                    <h3 className="flex-1 text-[15px] font-medium sm:text-base">{q}</h3>
                    <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-open:rotate-180 group-open:bg-[#12dfbd] group-open:text-[#102b37]">
                      <ChevronDown className="h-5 w-5" />
                    </span>
                  </summary>
                  <p className="px-5 pb-6 text-sm leading-[1.75] text-slate-700 sm:px-6 sm:text-[15px]">{a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* ================= CLOSING CTA ================= */}
        <section
          aria-labelledby="banking-cta-heading"
          className="w-full bg-white px-4 py-10 sm:px-10 sm:py-12 lg:px-14 lg:py-16"
        >
          <div className="relative isolate mx-auto w-full max-w-[1300px] overflow-hidden rounded-[1.5rem] border border-[#48247f]/10 bg-gradient-to-br from-[#f1ecfa] via-white to-[#e3faf5] px-5 py-12 text-center shadow-[0_20px_60px_-20px_rgba(72,36,127,0.25)] sm:rounded-[2rem] sm:px-12 sm:py-16">
            <div className="pointer-events-none absolute -right-20 -top-20 -z-10 h-72 w-72 rounded-full bg-[#12dfbd]/20 blur-3xl" />
            <h2
              id="banking-cta-heading"
              className="mx-auto max-w-2xl text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px]"
            >
              Ready to close{" "}
              <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                more loans, faster?
              </span>
            </h2>
            <p className="mx-auto mt-4 max-w-[560px] text-[15px] leading-[1.75] text-[#3b2a63] sm:text-base">
              See how LMSBOTS fits your lending workflow. We'll walk you through lead capture, RM
              assignment, KYC follow-ups, and reporting on a live demo.
            </p>
            <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
              <Link
                to="/contact"
                className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-7 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
              >
                Request a Demo
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <Link
                to="/pricing"
                className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-[#48247f]/20 bg-white px-7 py-3 text-xs font-medium text-[#48247f] shadow-sm transition-all duration-300 hover:border-[#702cb0]/50 hover:bg-[#f1ecfa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#48247f] focus-visible:ring-offset-2 sm:text-sm"
              >
                View Pricing
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Banking;